<template>
  <section>
    <table class="table table-striped" style="width: 100%">
      <thead class="thead-dark">
        <tr>
          <template v-if="context == 'SequenceEdit'">
            <th v-if="!currentSequence.isRandom" scope="col"></th>
            <th v-if="!currentSequence.isRandom" scope="col">
              {{ $t("Sequence.ORDER") }}
            </th>
          </template>
          <th
            v-if="context == 'SequenceEdit'"
            scope="col"
            class="has-text-centered"
          >
            {{ $t("ActivityEdit.NAME") }}
          </th>
          <th scope="col" class="has-text-centered">
            {{ $t("ActivityEdit.TITLES.TITLE") }}
          </th>

          <th scope="col" class="has-text-centered" style="min-width: 140px">
            <b-tooltip :label="$t('Sequence.REPETITIONS')">
              <b-icon icon="sync" style="vertical-align: bottom"></b-icon>
              <b-icon
                icon="times-circle"
                style="vertical-align: top"
                size="is-small"
              ></b-icon>
            </b-tooltip>
          </th>
          <th
            v-if="context == 'SequenceEdit'"
            scope="col"
            class="has-text-centered"
            style="min-width: 140px"
          >
            {{ $t("Sequence.COEFFICIENT") }}
          </th>
          <th
            v-if="context == 'SequenceEdit'"
            scope="col"
            class="has-text-centered"
            style="min-width: 140px"
          >
            {{ $t("Sequence.MAXATTEMPTS") }}
          </th>
          <th v-if="oneVersionAtLeast()" scope="col" class="has-text-centered">
            Version
          </th>
          <th v-if="isSettingsEditable && context == 'SequenceEdit'"></th>
          <th
            v-if="isSettingsEditable && context == 'Cart'"
            class="has-text-centered"
            scope="col"
          >
            <b-button
              type="is-danger"
              icon-left="trash"
              size="is-small"
              @click="removeAllActivities"
            >
            </b-button>
          </th>
        </tr>
      </thead>
      <template v-if="context == 'SequenceEdit'">
        <draggable
          v-if="activities.length > 0"
          v-model="localActivities"
          tag="tbody"
          :item-key="(item) => item.activity.id"
          handle=".handle"
          :disabled="!isSettingsEditable"
          @end="updateOrderActivities"
        >
          <template #item="{ element: item, index }">
          <tr
            :class="
              item.activity?.shared == 0 &&
              item?.activity?.userId != currentUser.id
                ? 'has-text-danger '
                : ''
            "
          >
            <td v-if="!currentSequence.isRandom">
              <b-icon icon="align-justify" class="handle"></b-icon>
            </td>
            <td v-if="!currentSequence.isRandom">{{ index + 1 }}</td>
            <td v-if="item?.activity?.userId == currentUser.id">
              {{ item.activity.name }}
            </td>
            <td v-else class="p-0">
              <b-button
                icon-left="share"
                :type="
                  item?.activity?.shared == 0
                    ? 'is-text has-text-danger'
                    : 'is-text has-text-info'
                "
                @click="
                  item?.activity?.shared != 0
                    ? goToActivity(item.activity.id)
                    : null
                "
              >
                ({{
                  getFullName(
                    item?.activity?.user?.firstName,
                    item?.activity?.user?.lastName
                  )
                }})<b-tooltip
                  v-if="item?.activity?.shared == 0"
                  position="is-top"
                  type="is-danger"
                  class="ml-2"
                  :label="$t('SequenceActivityListSettings.NOT_SHARED_ANYMORE')"
                >
                  <b-icon size="is-small" icon="question-circle"></b-icon>
                </b-tooltip>
              </b-button>
            </td>
            <td>
              {{ item.activity.langs[0].title }}
            </td>
            <td>
              <b-field>
                <b-numberinput
                  v-model="item.repetitions"
                  @update:model-value="updateRepetitionActivity(index, $event)"
                  controls-position="compact"
                  min="1"
                  max="20"
                  size="is-small"
                  expanded
                  :disabled="!isSettingsEditable"
                ></b-numberinput>
              </b-field>
            </td>

            <td>
              <b-field>
                <b-numberinput
                  v-model="item.coefficient"
                  @update:model-value="updateCoefficientActivity(index, $event)"
                  controls-position="compact"
                  min="0"
                  size="is-small"
                  expanded
                  :disabled="!isSettingsEditable"
                ></b-numberinput>
              </b-field>
            </td>
            <td>
              <template v-if="currentSequence.examMode === true"
                ><div class="has-text-centered">
                  1 ({{ $t("SequenceActivityListSettings.EXAMMODE") }})
                </div></template
              >
              <template v-else-if="!item.activity.hasNestedQuestion">
                <b-field>
                  <b-numberinput
                    v-model="item.maxAttempts"
                    @update:model-value="updateMaxAttemptsActivity(index, $event)"
                    controls-position="compact"
                    min="1"
                    size="is-small"
                    class="mb-0"
                    expanded
                    :disabled="!isSettingsEditable"
                  ></b-numberinput>
                </b-field>
              </template>

              <template v-else
                ><div class="has-text-centered">
                  {{ $t("Sequence.MAXATTEMPTS_BLOCKED") }}
                </div></template
              >
            </td>
            <td v-if="item.activity.versions?.length > 0">
              <b-field>
                <b-select
                  v-model="item.versionNumber"
                  @update:model-value="updateVersionNumberActivity(index, $event)"
                  :disabled="!isSettingsEditable"
                >
                  <option :value="-1" :key="-1">
                    {{ $t("Use.VERSION_RANDOM") }}
                  </option>
                  <option
                    v-for="version in item.activity.versions
                      .filter((version) => version.number != -1)
                      .sort((a, b) => a.number - b.number)"
                    :value="version.number"
                    :key="version.number"
                    :title="version.label.length > 40 ? version.label : ''"
                  >
                    {{
                      version.label.length > 40
                        ? version.label.substring(0, 20) +
                          " ... " +
                          version.label.slice(-20)
                        : version.label
                    }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="oneVersionAtLeast()"></td>

            <td v-if="isSettingsEditable" class="has-text-centered">
              <b-field grouped>
                <b-button
                  icon-left="clone"
                  type="is-text"
                  @click="duplicateActivity(index)"
                ></b-button>
                <b-button
                  icon-left="times"
                  type="is-text"
                  @click="removeActivity(index)"
                ></b-button>
              </b-field>
            </td>
          </tr>
          </template>
        </draggable>
      </template>
      <template v-if="context == 'Cart'">
        <tr v-for="(item, index) in localActivities" :key="index">
          <td>{{ item.title }}</td>
          <td>
            <b-field>
              <b-numberinput
                v-model="item.repetitions"
                @update:model-value="updateRepetitionActivity(index, $event)"
                min="1"
                max="20"
                size="is-small"
                expanded
                :disabled="!isSettingsEditable"
              ></b-numberinput>
            </b-field>
          </td>
          <!-- en admin on peut changer les versions dans le Cart-->
          <template v-if="isCurrentUserAdmin">
            <td v-if="item.versions?.length > 0">
              <b-field>
                <b-select
                  v-model="item.versionNumber"
                  @update:model-value="updateVersionNumberActivity(index, $event)"
                  :disabled="!isSettingsEditable"
                >
                  <option :value="-1" :key="-1">
                    {{ $t("Use.VERSION_RANDOM") }}
                  </option>
                  <option
                    v-for="version in item.versions
                      .filter((version) => version.number != -1)
                      .sort((a, b) => a.number - b.number)"
                    :value="version.number"
                    :key="version.number"
                  >
                    {{ version.label }}
                  </option>
                </b-select>
              </b-field>
            </td>
            <td v-else-if="oneVersionAtLeast()"></td>
          </template>
          <template v-else>
            <td v-if="item.versions?.length > 0">
              {{
                getVersionLabelFromVersionNumber(
                  item.versionNumber,
                  item.versions
                )
              }}
            </td>
            <td v-else-if="oneVersionAtLeast()"></td
          ></template>

          <td class="has-text-centered">
            <b-button
              icon-left="times"
              type="is-text"
              @click="removeActivity(index)"
            ></b-button>
          </td>
        </tr>
      </template>
    </table>
  </section>
</template>



<script>
import UtilsMixin from "../mixins/UtilsMixin.js";
import { mapState, mapGetters } from "vuex";

import draggable from "vuedraggable";

export default {
  name: "SequenceActivityListSelection",
  mixins: [UtilsMixin],
  components: {
    draggable,
  },

  props: {
    currentSequence: {
      type: Object,
    },
    activities: {
      type: Array,
      required: true,
      default: new Array(),
    },
    isSettingsEditable: {
      type: Boolean,
      default: true,
    },
    context: {
      type: String,
    },
  },

  watch: {
    activities: {
      // deep: true is required under Vue3 - unlike Vue2, in-place array mutations
      // (e.g. the Vuex store doing state.cart.push(...)) don't trigger a shallow prop watcher.
      handler(newActivities) {
        // Mettre à jour la copie locale si la prop change
        this.$emit("updateCart");
        //DEEP COPY to be compliant with vuex (otherwise mutate error when modified)
        this.localActivities = JSON.parse(JSON.stringify(newActivities));
      },
      deep: true,
    },
    /* localActivities: {
      handler(newLocalActivities) {
        console.log("updateSequenceActivityListSettings");
        // needs for sequenceEdit Only because Cart is directly modifying the store Cart
        this.$emit("updateSequenceActivityListSettings", newLocalActivities);
      },
      deep: true, // Surveille les modifications profondes dans le tableau
    },*/
  },
  data() {
    return {
      localActivities: JSON.parse(JSON.stringify(this.activities)), // Créer une copie locale des activités
      defaultRepetitions: 2,
    };
  },

  mounted() {},

  computed: {},

  methods: {
    oneVersionAtLeast() {
      if (this.$props.context === "SequenceEdit") {
        return this.$props.activities.some(
          (item) => item.activity?.versions && item.activity.versions.length > 0
        );
      } else if (this.$props.context === "Cart") {
        return this.$props.activities.some(
          (item) => item?.versions && item.versions.length > 0
        );
      }
      return false;
    },
    goToActivity(activityId) {
      this.$router.push(`/use/${activityId}`);
    },

    duplicateActivity(index) {
      this.$emit("duplicateActivity", index);
    },
    removeActivity(index) {
      this.$emit("removeActivity", index); // Émet l'événement avec l'index
    },
    removeAllActivities() {
      this.$emit("removeAllActivities");
    },
    updateOrderActivities(event) {
      const { oldIndex, newIndex } = event;
      console.log("updateRepetitionActivity", oldIndex, newIndex);
      if (oldIndex !== newIndex) {
        this.$emit("updateOrderActivities", oldIndex, newIndex);
      }
    },
    updateRepetitionActivity(index, repetitions) {
      console.log("updateRepetitionActivity", index, repetitions);
      //event suivant recu uniquement par Cart, pas utile pour SequenceEdit
      this.$emit("updateRepetitionActivity", index, repetitions);
    },
    updateCoefficientActivity(index, coefficient) {
      console.log("updateCoefficientActivity", index, coefficient);
      //event suivant recu uniquement par Cart, pas utile pour SequenceEdit
      this.$emit("updateCoefficientActivity", index, coefficient);
    },
    updateMaxAttemptsActivity(index, maxAttempts) {
      console.log("updateMaxAttemptsActivity", index, maxAttempts);
      //event suivant recu uniquement par Cart, pas utile pour SequenceEdit
      this.$emit("updateMaxAttemptsActivity", index, maxAttempts);
    },
    updateVersionNumberActivity(index, versionNumber) {
      console.log("updateVersionNumberActivity", index, versionNumber);
      //event suivant recu uniquement par Cart, pas utile pour SequenceEdit
      this.$emit("updateVersionNumberActivity", index, versionNumber);
    },
  },
};
</script>
